(function () {
    angular.module('tmx-app').controller('treasuryCtrl', ['$mdDialog','menu', '$state', 'lookupService', 'LoanApplicationService', 'ToastService', 'TreasuryService', '$mdSidenav', 'tmxUtility', 'cacheStore','TMX_FINANCE_CONSTANTS', 

        function TreasuryCtrl($mdDialog, menu,$state, lookupService, LoanApplicationService, ToastService, TreasuryService, $mdSidenav, tmxUtility, cacheStore,TMX_FINANCE_CONSTANTS) {

            var exists;
            var copy;
            var treasuryVM = this;
            exists = tmxUtility.exists;
            copy = tmxUtility.copy;
            treasuryVM.TreasuryService = TreasuryService;
            treasuryVM.gridData = new kendo.data.ObservableArray([]);
            treasuryVM.gridColumns = angular.copy(TreasuryService.columns);
            treasuryVM.menu=menu;
        //initializing Lookup types from Tmx Finance Constant
            var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;

            var loanTypeLookup = lookupService.getLocalLookupsByType(lkupType.LoanUsageTypes);
            var tenantName = "";


            (function populateConfigurations() {
                var configurations = cacheStore.get("Configurations");
                tenantName = tmxUtility.getConfigurationValue(configurations, 'INTEGRATION_TENANT').toLowerCase();

            })();

            treasuryVM.isFiltered = function (fieldName) {
                var filtered = false;
                if (angular.isDefined(treasuryVM.filters)) {
                    treasuryVM.filters.filters.forEach(function (filter) {
                        if (filter.field == fieldName) {
                            filtered = true;
                        }
                    });
                }
                return filtered;
            }

            treasuryVM.success = function (promise) {
                if (promise.read == true) {
                    treasuryVM.container.LoanInformationGrid.dataSource.transport.read(promise);
                }
                else {
                    treasuryVM.container.LoanInformationGrid.dataSource.read();
                }
                treasuryVM.toggleSearch(treasuryVM.nav);
            };

            treasuryVM.toggle = function (navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function () { });
            };

            treasuryVM.submitClick = function (dataItem) {
                $mdDialog.show({
                    controller: ['$mdDialog', '$scope', 'tmxUtility', 'lookupService', 'tmxResource', 'TMX_FINANCE_CONSTANTS', 'TmxDialogService', 'data', 'tenant',  submitInfoCtrl],
                    locals: {
                        data: dataItem,
                        tenant: tenantName
                    },
                    templateUrl: 'app/private/transaction/treasury/submit-information.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    fullscreen: true
                }).then(function (responseData) {
                    if (responseData) { }
                }, function () {

                });

            }

            function submitInfoCtrl($mdDialog, $scope, tmxUtility, lookupService, tmxResource, TMX_FINANCE_CONSTANTS,TmxDialogService, data, tenant) {


                $scope.data = data;
                $scope.showLoanEditableFields = false;
                var exists = tmxUtility.exists;   

            //initializing Lookup types from Tmx Finance Constant
                var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;
            
            //Currency Hidden Value
                var currencyTypes = TMX_FINANCE_CONSTANTS.CURRENCY_TYPES;

                function initLookups(){
                    $scope.lookup = {};
                    $scope.lookup.CommandsDropDown = [];
                    $scope.lookup.currencyLkp = lookupService.getLocalLookupsByType(lkupType.CURRENCY_WITH_RATE);
                    $scope.lookup.fundLkp = lookupService.getLocalLookupsByType(lkupType.Funds);
                    $scope.lookup.loanProductLkp = lookupService.getLocalLookupsByType(lkupType.LoanProducts);
                    $scope.lookup.nationalityLkp = lookupService.getLocalLookupsByType(lkupType.Nationalities);

                }

                function initFields(){
                
                    data.TmxCustomerMaster[0].ConvertedApprovedAmount =  data.ApprovedLoanAmount;
                    data.TmxCustomerMaster[0].ConvertedRequestedAmount =  data.RequestedLoanAmount;

                    data.TmxCustomerMaster[0].FinalApprovedAmount =  data.ApprovedLoanAmount;
                    data.TmxCustomerMaster[0].FinalRequestedAmount =  data.RequestedLoanAmount;


                    if (tenant == TMX_FINANCE_CONSTANTS.TENANTS.VITAS_LEB && tmxUtility.checkUserRole(TMX_FINANCE_CONSTANTS.ROLE_NAMES.Treasury)) {
                        $scope.showLoanEditableFields = true;
                    }

                    $scope.sourceHiddenValue = "";
                    if(exists(data.CurrencyId)){
                        $scope.lookup.currencyLkp.forEach(e => {
                            if(e.LookupId ==  data.CurrencyId){
                                $scope.sourceHiddenValue = e.HiddenValue;
                            }
                        });
                    }
                    else{
                        $scope.lookup.currencyLkp.forEach(e => {
                            if(e.VisibleValue == currencyTypes.usdCurrency){
                                $scope.sourceHiddenValue = e.HiddenValue;
                            }
                        });    
                    }

                    if (data.Commands) {
                        $scope.lookup.CommandsDropDown = tmxUtility.sortByAttr(data.Commands.map(x => {
                            return {
                                VisibleValue: x.VisibleValue,
                                HiddenValue: x.HiddenValue
                            }
                        }), "Classifier");
                    }
                }

                $scope.convertApproveRequestAmount = function(currency){

                    $scope.destHiddenValue = "";
                    var currencyVisibleValue = "";

                    if(exists(currency)){
                        $scope.lookup.currencyLkp.forEach(e => {
                            if(e.LookupId ==  currency){
                                $scope.destHiddenValue = e.HiddenValue;
                                currencyVisibleValue = e.VisibleValue;
                            }
                        });
                    }

                    if(exists(data.TmxCustomerMaster[0].ConvertedApprovedAmount) && exists($scope.destHiddenValue) && $scope.destHiddenValue != ""){

                        var mulResult = data.TmxCustomerMaster[0].ConvertedApprovedAmount * $scope.destHiddenValue;
                        data.TmxCustomerMaster[0].ConvertedApprovedAmount = mulResult / Number($scope.sourceHiddenValue);

                    //Round off currency value if currency selected is LBP
                        if(currencyVisibleValue == currencyTypes.lbpCurrency) {
                            data.TmxCustomerMaster[0].FinalApprovedAmount = Math.round(data.TmxCustomerMaster[0].ConvertedApprovedAmount/1000)*1000;
                        }
                        else{
                            data.TmxCustomerMaster[0].FinalApprovedAmount = data.TmxCustomerMaster[0].ConvertedApprovedAmount;
                        }
                    }

                    if(exists(data.TmxCustomerMaster[0].ConvertedRequestedAmount) && exists($scope.destHiddenValue) && $scope.destHiddenValue != ""){

                        var mulResult = data.TmxCustomerMaster[0].ConvertedRequestedAmount * $scope.destHiddenValue;
                        data.TmxCustomerMaster[0].ConvertedRequestedAmount = mulResult / Number($scope.sourceHiddenValue);

                    //Round off currency value if currency selected is LBP
                        if(currencyVisibleValue == currencyTypes.lbpCurrency) {
                            data.TmxCustomerMaster[0].FinalRequestedAmount = Math.round(data.TmxCustomerMaster[0].ConvertedRequestedAmount/1000)*1000;
                        }
                        else{
                            data.TmxCustomerMaster[0].FinalRequestedAmount = data.TmxCustomerMaster[0].ConvertedRequestedAmount;
                        }
                    }

                    if(exists($scope.destHiddenValue) && $scope.destHiddenValue != ""){
                        $scope.sourceHiddenValue = $scope.destHiddenValue;
                    }
                

                }

                function prePopulateLkp() {
                    if(exists(data.TmxCustomerMaster[0].LoanProduct)){
                        $scope.populateSubProduct(data.TmxCustomerMaster[0].LoanProduct);
                    }

                    if(exists(data.TotalTenure)){
                        $scope.populateDisbursedAcc(data.TotalTenure);
                    }
                }         

                $scope.populateDisbursedAcc = function (fundId) {

                    if(exists(fundId)){
                        $scope.lookup.disbursedAccLkp = lookupService.getByTypeAndParentLocal('DisbursementBankAccounts', fundId);
                    }
                    else{
                        data.OtherLoanInstituteNameValue = null
                    }

                }

                $scope.populateSubProduct = function (loanProduct) {

                    if(exists(loanProduct)){
                        $scope.lookup.loanProductParamLkp = lookupService.getByTypeAndParentLocal('LoanProductParameterSets', loanProduct);
                    }
                    else{
                        data.TmxCustomerMaster[0].LoanSubProduct = null;
                    }
                
                }

                $scope.ok = function (commandHiddenValue) {

                    if (exists(commandHiddenValue) && $scope.submitInfoCtrl.dialogForm.$valid) {
                        let loggedinUserInfo = cacheStore.get('GetInfoOfLoggedInUser');
                        var executeData = {
                            "Command": commandHiddenValue,
                            "ProcessID": data.ProcessInstanceId,
                            "ApplicationId": data.LoanApplicationID,
                            "UserId": loggedinUserInfo.userId,
                        }

                        if ($scope.showLoanEditableFields == true) {
                        //First Update the rows
                            tmxResource('LoanApplication').getByAction('UpdateTreasuryApp', true, 'put', data).then(function (response) {
                                if (response.status.code == "200") {
                                    ExecuteCommand(executeData);
                                }
                                else {
                                    ToastService.showCustomToast("error", "There was an error in data update");
                                }
                            });
                        }


                    }
                    else {
                        ToastService.showCustomToast("error", "Please select Command to Execute");
                    }

                }


                $scope.cancel = function () {
                    $mdDialog.hide();
                };

                function ExecuteCommand(executeData) {
                    LoanApplicationService.getByAction("ExecuteWf", false, "put", executeData).then(function (response) {
                        if (response.data && response.data != null) {

                            if (response.data.status && response.data.status.code == 417) {
                                var validationText = "";
                                if (exists(response.data.data) && exists(response.data.data.Errors) && response.data.data.Errors.length > 0) {
                                    response.data.data.Errors.forEach(function (val) {
                                        validationText += val + "<br>";
                                    });
                                }
                                TmxDialogService.showAlertDialog("Validation Rules", validationText);
                                $('#grid').data('kendoGrid').dataSource.read();

                            }
                            else if (exists(response.data.data) && exists(response.data.data.error) && response.data.data.error.length > 0) {
                                var errorMessages = "";
                                response.data.data.error.forEach(function (val) {
                                    errorMessages += val + "<br>";
                                });
                                TmxDialogService.showAlertDialog("Errors", errorMessages);
                                $('#grid').data('kendoGrid').dataSource.read();
                            }
                            else if (exists(response.data.data) && response.data.wFDeviation) {
                                var validationText = "";
                                if (exists(response.data.wFDeviation) && response.data.wFDeviation.length > 0) {
                                    response.data.wFDeviation.forEach(function (val, index) {
                                        validationText += index + 1 + ') ' + val + "<br>";
                                    });
                                }
                                TmxDialogService.showAlertDialog("WorkFlow Deviation(s)", validationText, function () {
                                    ToastService.showCustomToast("success", "Requested action has been successfully performed on application.");
                                });
                                $('#grid').data('kendoGrid').dataSource.read();
                            }
                            else if((response.data.status && response.data.status.code == 400) ||  (exists(response.data.data) && response.data.manualDeviation )) {
                                ToastService.showCustomToast("error", "Requested action could not be performed on the application. Please open the application from inbox and try again.");
                                $('#grid').data('kendoGrid').dataSource.read();
                            }
                            else {
                                ToastService.showCustomToast("success", "Requested action has been successfully performed on application.");
                                $('#grid').data('kendoGrid').dataSource.read();
                            }
                        }        
                        $mdDialog.hide();
                    });
                }


                (function InitializeController() {
                    initLookups();
                    initFields();
                    prePopulateLkp();                             
                })();

            }

            treasuryVM.loanTypeOptions = {

                dataSource: {

                    data: loanTypeLookup,
                },
                autobind: false,
                dataTextField: 'VisibleValue',
                dataValueField: 'LookupId',
                select: function (e) {
                    var item = e.item;
                    var data = item.data();
                    e.sender.$angular_scope.dataItem.CurrencyId = data.$scope.dataItem.LoanType;
                }
            };


            treasuryVM.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function (o) {
                            if (angular.isDefined(treasuryVM.searchClear) && treasuryVM.searchClear == false) {
                                if (exists(treasuryVM.o)) {
                                    copy(treasuryVM.o.data, ["filter"], o.data);
                                }
                            }
                            treasuryVM.searchClear = false;
                            if (!o.fromSideNav) {
                                if ($state.searchClear) {
                                    treasuryVM.searchClear = true;
                                    $state.searchClear = undefined;
                                //return;
                                }
                            //if(exists(vm.o))
                            //    copy(vm.o.data,["filter"],o.data);
                            }
                            else
                                o.data.firstPage = true;

                            treasuryVM.o = angular.copy(o);
                            treasuryVM.filters = treasuryVM.o.data.filter;

                            LoanApplicationService.getByParams(o, true, "/TreasuryInbox").then(function (response) {
                                o.success(response);
                            });
                        },
                        dataType: "json"
                    },
                    schema: {
                        model: {
                            id: "LoanApplicationID",
                            fields: {
                                CustomerName: { editable: false, type: "text" },
                                LoanApplicationNumber: { editable: false, type: "text" },
                                ProductName: { editable: false, type: "text" },
                                CreatedBy: { editable: false, type: "text" },
                                BranchName: { editable: false, type: "text" },
                                ApprovedLoanAmount: { editable: false, type: "number" },
                                TotalInstallments: { editable: false, type: "number" },
                                LoanPurpose: { editable: false, type: "text" },
                                LoanType: { editable: false, type: "text" },

                                Currency: { title: 'Currency', editable: false },
                                TotalTenure: { title: 'TotalTenure', editable: false, scrollable: false },
                                OtherLoanInstituteName: { type: "text", editable: true }
                            }
                        },
                        data: "data",
                        total: "Total"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    sort: [{ field: "CreatedDate", dir: "desc" }],
                },
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 5,
                    buttonCount: 2
                },
                sortable: true,
                scrollable: false,
                columns: treasuryVM.gridColumns,
                editable: true
            };
        }]);
})();